import React, { Suspense } from "react";
import "./App.css";
import "./i18n";
import Hero from "./components/Hero";
import Header from "./components/Header";
import Marquee from "./components/Marquee";
import CardLayout from "./components/CardLayout";
import Oneliner from "./components/Oneliner";
import Bio from "./components/Bio";
// import Promotion from "./components/Promotion";
import Images from "./components/Images";
import Calendly from "./components/Calendly";
import Footer from "./components/Footer";
// import AudioPlayer from './components/AudioPlayer';

function App() {
  return (
    <div className="App">
      <Suspense fallback={<div>Loading translations...</div>}>
        <Header />
        <Hero />
        <Marquee />
        <CardLayout />
        <Oneliner />
        <Bio />
        {/* <Promotion /> */}
        <Images />
        <Calendly />
        {/* <AudioPlayer src="/audio/test.mp3" /> */}
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;
